import { updateCookie } from '../utils/browserCookieWrapper';

export const APPCACHE_UNINSTALLER: string = 'appcacheuninstaller';
export const APPCACHE_PATH = 'owa/manifests/appCacheManifestHandler.ashx';
export const APPCACHE_PATH_QUERY = '?manifest=0&layout=mouse&UA=0';
export const APPCACHE_UNINSTALL_COOKIENAME: string = 'UnInstallAppcache';
export const APPCACHE_OBSOLETE_KEY: string = 'AppcacheObsolete';

let iframe: HTMLIFrameElement = null;

export default function cleanupLegacyAppcache(windowObj: Window) {
    if (!windowObj.applicationCache) {
        return;
    }

    if (isAppcacheObsolete(windowObj)) {
        return;
    }

    iframe = windowObj.document.createElement('iframe');
    iframe.src = getAppcacheManifestPath(windowObj.location.href);
    iframe.setAttribute('id', APPCACHE_UNINSTALLER);
    iframe.style.display = 'none';
    iframe.onload = () => {
        iframe.onload = null;
        try {
            attachAppCacheEventHandler(windowObj);
        } catch (e) {
            onCompleted(windowObj);
        }
    };

    updateCookie(APPCACHE_UNINSTALL_COOKIENAME, 'true', { path: '/' });
    windowObj.document.body.appendChild(iframe);
}

function getAppcacheManifestPath(parentHref: string): string {
    const url: URL = new URL(parentHref);
    url.pathname = APPCACHE_PATH;
    url.search = APPCACHE_PATH_QUERY;
    return url.href;
}

function attachAppCacheEventHandler(windowObj: Window) {
    const appCache: ApplicationCache = iframe.contentWindow.applicationCache;
    appCache.onobsolete = () => {
        onCompleted(windowObj);
        detachAppCacheEventHandlers(appCache);
    };

    appCache.onerror = () => {
        onCompleted(windowObj);
        detachAppCacheEventHandlers(appCache);
    };
}

function detachAppCacheEventHandlers(appCache: ApplicationCache) {
    appCache.onerror = null;
    appCache.onobsolete = null;
}

function onCompleted(windowObj: Window) {
    setAppcacheObolete(windowObj);
    updateCookie(APPCACHE_UNINSTALL_COOKIENAME);
    windowObj.document.body.removeChild(iframe);
    iframe = null;
}

function isAppcacheObsolete(windowObj: Window): string {
    let obsolete: string = null;
    if (windowObj.localStorage != null) {
        obsolete = windowObj.localStorage.getItem(APPCACHE_OBSOLETE_KEY);
    }

    return obsolete;
}

function setAppcacheObolete(windowObj: Window) {
    if (windowObj.localStorage != null) {
        try {
            windowObj.localStorage.setItem(APPCACHE_OBSOLETE_KEY, '1');
        } catch (e) {}
    }
}
